import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { purgeLegacyBiometricEntry } from './utils/biometricAuth';
import { installPreloadErrorReload } from './utils/chunkReload';
import './styles/main.css';

// An earlier build of biometric sign-in kept the user's real PASSWORD in the
// keychain. One phone in the wild has such an entry. Delete it at launch,
// before any screen can offer to use it — it is never traded in for a device
// token, because doing that would mean sending the stored password. The user
// signs in once with their password and is offered biometrics again.
// No-ops on the web and on a phone that never enabled it.
purgeLegacyBiometricEntry().catch(() => { /* nothing stored, or no plugin */ });

// A tab left open across a deploy asks for chunk files that no longer exist;
// reload once onto the new build rather than showing an error.
installPreloadErrorReload();

// Register service worker in production only.
// In development (Vite dev server) the SW is intentionally skipped to avoid
// caching issues during active development.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[SW] Registered, scope:', registration.scope);
        // Desk tabs stay open for days; check hourly so a new worker
        // arrives without waiting for a reload.
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch((err) => {
        // Non-fatal — app works without SW, just no offline support
        console.warn('[SW] Registration failed:', err);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
